(function () {
	'use strict';
	angular.module('smb-app')
		.directive('smbUserAdministration',
		[
			UserAdminDirective
		])
		.controller('UserAdminController',
		[
			'smbToolbarService',
			'gettextCatalog',
			UserAdminController
		]);

	var templateUrl = require('./userAdmin.template');
	function UserAdminDirective() {
		return {
			restrict: 'E',
			controller: UserAdminController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {}
		};
	}
	function UserAdminController(smbToolbarService, gettextCatalog) {
		smbToolbarService.set(gettextCatalog.getString('User Administration'), 'content.home', false, false);

		var vm = this;
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/components/userAdmin/userAdmin.js
// module id = 101
// module chunks = 1